/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import * as _ from 'underscore';

class UncontrolledTextInput extends React.Component {
    constructor(props) {
        super(props);

        let date = new Date(),
            refName = (this.props.refName && this.props.refName !== '') ? this.props.refName : (Math.round(Math.random() * date.getTime()).toString());

        this[refName] = React.createRef();

        this.state = {
            refName
        };

    }

    componentDidMount() {
        if (this.props.focus) {
            if (this[this.state.refName].current) {
                this[this.state.refName].current.focus();
            }
        }
    }

    render() {
        // clone props and remove refName if present since spread attributes are used
        // for the input element and this keeps refName from being rendered
        let {refName, focus, isTextArea, isPassword, ...otherProps} = this.props,
            type = "text";

        if (isPassword) {
            type = "password";
        }

        if (this[this.state.refName].current && (this[this.state.refName].current.value === '' && this.props.defaultValue !== undefined && this.props.defaultValue !== '')) {
            this[this.state.refName].current.value = this.props.defaultValue;
        }

        if (isTextArea === true) {
            return (
                <textarea ref={this[this.state.refName]} {...otherProps}/>
            );
        } else {
            return (
                <input type={type} ref={this[this.state.refName]} {...otherProps} />
            );
        }

    }

};

UncontrolledTextInput.displayName = "UncontrolledTextInput";

UncontrolledTextInput.defaultProps = {
    focus: PropTypes.bool,
    isTextArea: PropTypes.bool
};

UncontrolledTextInput.defaultProps = {
    focus: false,
    isTextArea: false
};

export default UncontrolledTextInput;
